export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SimpleVerticalIndicator.vue?vue&type=template&id=2baab9e4&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/SimpleVerticalIndicator.vue?vue&type=template&id=2baab9e4&scoped=true
// module id = lt8H
// module chunks = 41